import React from "react";

// Glyphs from the legacy Assests/Category/editIcon.svg and deleteIcon.svg,
// without the tile rects baked into those files, and tinted with theme tokens.

export const TaxEditIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 13.4"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M9.161,0A2.757,2.757,0,0,1,11.2,4.694Q9.395,6.509,7.581,8.317A5.667,5.667,0,0,1,4.47,9.9c-.607.108-1.21.237-1.815.356a.753.753,0,0,1-.915-.925c.164-.814.312-1.631.5-2.439a4.928,4.928,0,0,1,1.31-2.346Q5.443,2.627,7.359.735A2.6,2.6,0,0,1,9.161,0M3.452,8.554c.243-.047.458-.094.675-.129a4.207,4.207,0,0,0,2.366-1.16q1.8-1.807,3.607-3.609A1.246,1.246,0,1,0,8.341,1.891C7.135,3.09,5.941,4.3,4.73,5.5A4.968,4.968,0,0,0,3.452,8.554"
      transform="translate(-0.47 0)"
      fill="var(--qv-text, #0a0a0a)"
    />
    <path
      d="M6.5,17.744q-2.834,0-5.667,0a.745.745,0,0,1-.8-.552.744.744,0,0,1,.67-.956c.05,0,.1,0,.151,0H12.166a.761.761,0,0,1,.763.448.748.748,0,0,1-.691,1.063c-.881.007-1.763,0-2.645,0H6.5"
      transform="translate(0.001 -4.441)"
      fill="var(--qv-brand, #0a64f9)"
    />
  </svg>
);

export const TaxDeleteIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15.2 15"
    aria-hidden="true"
    focusable="false"
  >
    <g fill="var(--qv-danger, #d82424)">
      <path
        d="M586.655,228H571.5v1.443h1.6v8.9a2.168,2.168,0,0,0,2.165,2.165h7.618a2.167,2.167,0,0,0,2.165-2.165v-8.9h1.6Zm-3.047,10.344a.723.723,0,0,1-.722.722h-7.618a.722.722,0,0,1-.722-.722v-8.9h9.061Z"
        transform="translate(-571.5 -225.514)"
      />
      <rect width="6.495" height="1.443" x="4.33" />
      <rect width="1.443" height="4.571" x="5.292" y="6.335" />
      <rect width="1.443" height="4.571" x="8.419" y="6.335" />
    </g>
  </svg>
);
